import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';
import { ContextFiles } from '@widgets/Files/model/context';

interface CreateFolderButtonProps {
    classes?: string;
}

export const CreateFolderButton = ({ classes }: CreateFolderButtonProps) => {
    const { onChangeModalMode } = useContext(ContextFiles);
    const { t } = useTranslation();
    return (
        <UiButton
            btnText={t('Files.FolderModal.Create.Header')}
            variant="text"
            onClick={() => onChangeModalMode('folderCreate')}
            btnColor="primary"
        />
    );
};
